import { googleLocation } from './google-location/google-location.module';
import { googleMap } from './google-map/google-map.module';
import { slider } from './slider/slider.module';
import { modal } from './modal/modal.module';
import { highmaps } from './highmaps/highmaps.module';
import { breadcrumb } from './breadcrumb/breadcrumb.module';
import { listDropdown } from './list-dropdown/list-dropdown.module';
import { daysOfOperation } from './days-of-operation/days-of-operation.module';
import { featureMainPageTemplate } from './feature-main-page-template/feature-main-page-template.module';
import { featureDescriptionPageTemplate } from './feature-description-page-template/feature-description-page-template.module';
import { transportationAlternativesPageTemplate1 } from './transportation-alternatives-page-template1/transportation-alternatives-page-template1.module';
import { transportationAlternativesPageTemplate2 } from './transportation-alternatives-page-template2/transportation-alternatives-page-template2.module';
import { reportsPageTemplate } from './reports-page-template/reports-page-template.module';
import { displayCoverPic } from './display-cover-pic/display-cover-pic.module';
import { referenceMapsSwitchTab } from './reference-maps-switch-tab/reference-maps-switch-tab.module';
import { pagination } from './pagination/pagination.module';
import { searchBox } from './search-box/search-box.module';
import { pageContentCount } from './page-content-count/page-content-count.module';
import { phoneNumberFormat } from './phone-number-format/phone-number-format.module';
import { printScreen } from './print-screen/print-screen.module';
import { timepicker } from './timepicker/timepicker.module';
import { datepicker } from './datepicker/datepicker.module';
import { tripProviderSlider } from './trip-provider-slider/trip-provider-slider.module';
import { tripProviderDetails } from './trip-provider-details/trip-provider-details.module';
import { tripPlannerPrint } from './trip-planner-print/trip-planner-print.module';
import { socialShare } from './social-share/social-share.module';
import { selectDropdown } from './select-dropdown/select-dropdown.module';
import { radioTemplate } from './radio-template/radio-template.module';
import { loader } from './loader/loader.module';
import { reportPage } from './report-page/report-page.module';

export const components = angular
    .module('common.components', [
        googleLocation,
        googleMap,
        slider,
        modal,
        highmaps,
        breadcrumb,
        listDropdown,
        daysOfOperation,
        featureMainPageTemplate,
        featureDescriptionPageTemplate,
        transportationAlternativesPageTemplate1,
        transportationAlternativesPageTemplate2,
        reportsPageTemplate,
        displayCoverPic,
        referenceMapsSwitchTab,
        pagination,
        searchBox,
        pageContentCount,
        phoneNumberFormat,
        printScreen,
        timepicker,
        datepicker,
        tripProviderSlider,
        tripProviderDetails,
        tripPlannerPrint,
        socialShare,
        selectDropdown,
        radioTemplate,
        loader,
        reportPage
    ])
    .name;


// WEBPACK FOOTER //
// ./src/app/common/components/components.module.js